module.exports = __webpack_public_path__ + "static/img/product-top-4.c7035f94.png";